<template>
    <div class="modal fade"  id="json_modal"  tabindex="-1"  role="dialog">
        <div class="modal-dialog mx-auto" role="document" style="min-width:80% !important;">
            <div class="modal-content"  style="overflow:hidden;">
                <div class="modal-header"  style="font-size:24px; background-color:whitesmoke;">
                    <span class="align-self-center modal-title">Stellar Network Verification</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
        
                <div class="modal-body text-left"  style="">
                    <table  width=100%  style="max-width:700px; table-layout:fixed; margin-left:auto; margin-right:auto;">
                        <tbody>
                            <tr>
                                <td  style='width:150px; padding-left:5px; padding-right:20px; text-align:right;'><b>Date:</b></td>
                                <td>{{ email.date | moment("Do MMM YYYY, HH:mm:ss") }}</td>
                            </tr>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'><b>Subject:</b></td>
                                <td>{{ email.subject }}</td>
                            </tr>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'><b>To:</b></td>
                                <td>{{ email.to }}</td>
                            </tr>
                            <tr>
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'><b>cc:</b></td>
                                <td>{{ email.cc }}</td>
                            </tr>
                            <tr><td colspan=2><small>&nbsp;</small></td></tr>

                            <!-- CONTENTS (body text) HASH -->
                            <tr  style="overflow: hidden;">
                                <td  style='padding-left:5px; padding-right:20px; vertical-align:top; text-align:right;'>Contents DDNA:</td>
                                <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    <small class="text-monospace">
                                        {{ email.body_plain_hash }} <small>[{{ email.body_plain_hash_type }}]</small>
                                    </small>
                                </td>
                            </tr>
                            <tr v-if="body_checking == true">
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                                </td>
                                <td><small class="text-muted">please wait</small></td>
                            </tr>
                            <tr v-else-if="body_transaction">
                                <td  v-if="body_transaction.memo == email.body_plain_hash"
                                     style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                                </td>
                                <td  v-else
                                     style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                                </td>
                                <td>
                                    {{ body_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                    <br>
                                    <a :href="explorer_link + email.body_plain_stellar_tx_id" target='_blank'>Check using external tool</a>
                                </td>
                            </tr>
                            <tr v-else >
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                                </td>
                                <td></td>
                            </tr>
                            <tr><td colspan=2><small>&nbsp;</small></td></tr>

                            <!-- ADDRESSES-SUBJECT HASH -->
                            <tr  style="overflow: hidden; text-overflow: ellipsis;">
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'>Recipient DDNA:</td>
                                <td  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                    <small class="text-monospace">
                                        {{ email.addresses_subject_hash }} <small>[{{ email.addresses_subject_hash_type }}]</small>
                                    </small>
                                </td>
                            </tr>
                            <tr v-if="addsub_checking == true">
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-info"  style='font-variant:small-caps;'>checking ...</span>
                                </td>
                                <td><small class="text-muted">please wait</small></td>
                            </tr>
                            <tr v-else-if="addsub_transaction">
                                <td  v-if="addsub_transaction.memo == email.addresses_subject_hash"
                                     style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-success"  style='font-variant:small-caps;'>verified</span>
                                </td>
                                <td  v-else
                                     style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-danger"  style='font-variant:small-caps;'>error</span>
                                </td>
                                <td>
                                    {{ addsub_transaction.created_at | moment("HH:mm:ss, Do MMM YYYY") }}
                                    <br>
                                    <a :href="explorer_link + email.addresses_subject_stellar_tx_id" target='_blank'>Check using external tool</a>
                                </td>
                            </tr>
                            <tr v-else >
                                <td  style='padding-left:5px; padding-right:20px; text-align:right;'>
                                    <span class="btn btn-xs btn-warning"  style='font-variant:small-caps;'>not found</span>
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="modal-footer">
                    <button type="button" class="ml-auto btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    var stellar_sdk = require("stellar-sdk");

    export default {
        name: "Email_Stellar_viewer",
        props: [
            'email'
        ],
        components: {},

        computed: {},

        watch: {
            // Get transaction details from Stellar Network
            'email': function(email) {
                //console.log('email_stellar: id=', this.email.id);
                //console.log('email=', this.email);
                this.get_body_transaction(this.email.body_plain_stellar_tx_id);
                this.get_addsub_transaction(this.email.addresses_subject_stellar_tx_id);
            },
        },

        created() {
            // Set "Explorer" link
            if (process.env.VUE_APP_ENV != "production") {
                this.explorer_link = 'https://testnet.steexp.com/tx/';
            }
            else {
                this.explorer_link = 'https://steexp.com/tx/';
            }

            // Connect Stellar SDK
            this.stellar_server = new stellar_sdk.Server(this.$store.getters.GET_STELLAR_NETWORK_URL);
            if (typeof this.email != 'undefined'  &&  this.email != '') {
                this.get_body_transaction(this.email.body_plain_stellar_tx_id);
                this.get_addsub_transaction(this.email.addresses_subject_stellar_tx_id);
            }
        },
        mounted() {},

        data() {
            return {
                explorer_link:     '',

                body_checking:      true,
                body_transaction:   null,
                addsub_checking:    true,
                addsub_transaction: null,
            };
        },

        methods: {
            close() {
                this.$emit('close');
            },

            b64decode(str) {		
                return atob(str);
            },
            toHex(str) {
                var hex = '';
                var c   = '';

                for (var i=0; i < str.length; i++) {
                    c = str.charCodeAt(i).toString(16);
                    if (c.length < 2) {
                        hex += '0';
                    }
                    hex += ''+str.charCodeAt(i).toString(16);
                }

                return hex;
            },

            get_body_transaction: async function(id) {
                let _self = this;

                _self.body_checking    = true;
                _self.body_transaction = null;
    
                // Fetch
                if (id != null  &&  id != '') {
                    await _self.stellar_server.transactions()
                        .transaction(id)
                        .call()
                        .then(function (result) {
                            //console.log('SDK result =', result);
                            // Base64 decode memo
                            if (result.hasOwnProperty('memo')) {
                                result.memo = _self.toHex(_self.b64decode(result.memo)); 
                            }

                            _self.body_checking    = false;
                            _self.body_transaction = result;
                        })
                        .catch(function (error) {
                            _self.body_checking    = false;
                            //console.log('SDK Error:', error);
                        });    
                }
                else {
                    _self.body_checking = false;
                }
            },  

            get_addsub_transaction: async function(id) {
                let _self = this;

                _self.addsub_checking    = true;
                _self.addsub_transaction = null;
    
                // Fetch
                if (id != null  &&  id != '') {
                    await _self.stellar_server.transactions()
                        .transaction(id)
                        .call()
                        .then(function (result) {
                            //console.log('Owner SDK result =', result);
                            // Base64 decode memo
                            if (result.hasOwnProperty('memo')) {
                                result.memo = _self.toHex(_self.b64decode(result.memo)); 
                            }

                            _self.addsub_checking    = false;
                            _self.addsub_transaction = result;
                        })
                        .catch(function (error) {
                            _self.addsub_checking    = false;
                            //console.log('SDK Error:', error);
                        });    
                }
                else {
                    _self.addsub_checking = false;
                }
            },  
        },
    };
</script>
<style>
</style>